















































import Header from '@/components/common/Header.vue';
import { Component, Vue } from 'vue-property-decorator';
import { trialService } from '@/services/TrialService';
import { workspaceAccessService } from '@/services/WorkspaceAccessService';
import PromocodeInfobox from '@/components/activation/PromocodeInfobox.vue';

@Component({
  components: {
    Header,
    PromocodeInfobox,
  },
})
export default class PromocodeTrial extends Vue {
  workspaceId = 0;
  code = '';
  isActiveCodeValidation = false;
  errors: any = [];
  isLoading = false;

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
  }

  sendConfirmationCode() {
    this.errors = [];
    this.isActiveCodeValidation = true;
    if (this.code.length === 0) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    trialService
      .postPromocode(this.workspaceId, this.code)
      .then(() => {
        this.isLoading = false;
        workspaceAccessService.refreshWorkspaces().then(() => {
          this.$router.push(`/workspaces/${this.workspaceId}/intro`).catch(() => {});
        });
      })
      .catch(data => {
        this.isLoading = false;
        if (data && data.data && data.status === 422) {
          let error = data.data.error || {};
          if (error === 'trial_code_invalid') {
            this.errors.push(this.$t('trial_code_invalid'));
          }
          if (error === 'trial_code_used') {
            this.errors.push(this.$t('trial_code_invalid'));
          }
          if (error === 'trial_used') {
            this.errors.push(this.$t('trial_used'));
          }
        }
      });
  }
}
